import React, {Component} from 'react'
import ProductHits from './product-hits'

export default class ProductResults extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {collection, resultsIndex} = this.props

        return (
            <div className="padding-top-3x padding-bottom-3x wide">
                <ProductHits collection={collection} resultsIndex={resultsIndex}/>
            </div>
        )
    }
}
